export const NOTIFICARE_SECTION_LABELS: Record<string, string> = {
  company: "Identificare Companie",
  financial: "Date Financiare",
  contacts: "Date Contact",
  services: "Servicii NIS2",
  relatie_stat: "Relația cu Statul Român",
  servicii_ue: "Servicii în UE",
  classification: "Clasificare NIS2",
  documente_anexate: "Documente Anexate",
  confirmations: "Confirmări",
};
